import { ANIMATE } from '@namespace/top/animate'
import { SEASON_PARTICLES } from '@namespace/top/seasonParticles'
// import { VIDEO } from '@namespace/top/video'

export default function top() {
  const init = () => {
    ANIMATE.init()
    SEASON_PARTICLES.init()
    // VIDEO.init()
  }

  if (document.readyState === 'complete') {
    init()
  } else {
    window.addEventListener('load', init)
  }
}
